import React from 'react';
import { ArrowRight, Linkedin, MapPin, Download } from 'lucide-react';
import { Button } from './ui/button';
import { profileData } from '../data/mock';

const RESUME_URL = "https://customer-assets.emergentagent.com/job_b017b211-7a28-49ed-855c-ebb37ce8c7af/artifacts/jh6l88di_Resume-Pramith%20Rajapaksa%20%281%29.pdf";

const Hero = () => {
  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="min-h-screen flex items-center justify-center bg-white pt-16">
      <div className="max-w-6xl mx-auto px-6 lg:px-8 py-16 lg:py-24">
        <div className="max-w-3xl">
          {/* Availability badge */}
          <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-gray-50 rounded-full mb-8">
            <span className="w-2 h-2 bg-emerald-500 rounded-full animate-pulse" />
            <span className="text-sm text-gray-600">Available for opportunities</span>
          </div>

          {/* Headline */}
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-light text-gray-900 leading-tight tracking-tight mb-4">
            {profileData.headline}
          </h1>

          {/* Tech stack tagline */}
          <p className="text-lg text-gray-500 font-mono mb-6">
            {profileData.tagline}
          </p>

          {/* Intro */}
          <p className="text-lg text-gray-600 leading-relaxed mb-10 max-w-2xl">
            {profileData.intro}
          </p>

          {/* CTAs */}
          <div className="flex flex-col sm:flex-row gap-3 mb-10">
            <Button
              onClick={() => scrollToSection('#projects')}
              className="bg-gray-900 hover:bg-gray-800 text-white px-6 py-3 rounded-lg text-base transition-all hover:shadow-lg inline-flex items-center gap-2 group"
            >
              View Projects
              <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
            </Button>
            <Button
              variant="outline"
              onClick={() => scrollToSection('#contact')}
              className="border-gray-300 text-gray-700 hover:bg-gray-50 hover:border-gray-400 px-6 py-3 rounded-lg text-base transition-all"
            >
              Contact Me
            </Button>
            <a
              href={RESUME_URL}
              target="_blank"
              rel="noopener noreferrer"
              download="Pramith_Rajapaksa_Resume.pdf"
            >
              <Button
                variant="outline"
                className="border-blue-200 text-blue-600 hover:bg-blue-50 hover:border-blue-300 px-6 py-3 rounded-lg text-base transition-all inline-flex items-center gap-2 w-full sm:w-auto"
              >
                <Download className="w-4 h-4" />
                Download Resume
              </Button>
            </a>
          </div>

          {/* Meta info */}
          <div className="flex flex-wrap items-center gap-4 text-sm text-gray-500">
            <div className="flex items-center gap-1.5">
              <MapPin className="w-4 h-4" />
              <span>{profileData.location}</span>
            </div>
            <span className="text-gray-300">·</span>
            <span>{profileData.experience} experience</span>
            <span className="text-gray-300">·</span>
            <a
              href={profileData.linkedin}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1.5 hover:text-blue-600 transition-colors"
            >
              <Linkedin className="w-4 h-4" />
              <span>LinkedIn</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
